// removed by extract-text-webpack-plugin
module.exports = {"main":"t9hPyF8z2jPlx5jQ-Oo2X"};


//////////////////
// WEBPACK FOOTER
// ./components/ReceiptHeader.module.css
// module id = 2366
// module chunks = 1